import { render, staticRenderFns } from "./KnGroupClassroom.vue?vue&type=template&id=6812a4d2"
import script from "./KnGroupClassroom.js?vue&type=script&lang=js&external"
export * from "./KnGroupClassroom.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports